<div class="container-fluid">
  <app-report reportId="collectiveUserDashboard" screen="EXBDASHUSERS"></app-report>
</div>
